export default "__VITE_ASSET__BEpaThM5__"